import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { ratePlanCodes } from 'src/constants'
import { PlanIntervals } from 'src/constants/planData'
import { canadaPlanData } from 'src/constants/planData/canadaPlanData'
import { videos } from 'src/constants/videos'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'
import { WEB_MARKETING_CA_VALUE_PROPS } from 'src/modules/reducers/cohorts/constants'
import styled from 'styled-components'

export default (props) => {
  const showValueProps = useCohortFlag(WEB_MARKETING_CA_VALUE_PROPS)
  const valuePropsCopy = ['Unlimited Cloud DVR', 'Cancel Anytime', 'Every out-of-market game']
  return (
    <StyledContainer>
      <CanadaTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        video={videos.mlbtv.videoUrl}
        staticAnnotation={videos.mlbtv.staticAnnotation}
        title="Get MLB.TV with Fubo"
        subtitle="See every out-of-market game. As low as $19.99/mo."
        networkSubtitle="Watch Premier League, Serie A, MLB & so much more?"
        networkSet="canadaEssentials"
        customNetworks={['mlbtv']}
        league="mlb"
        hideNetworkSection={true}
        hidePlatformSection={true}
        hideFAQSection={true}
        hideDealSection={true}
        channelPlanCode={ratePlanCodes.canada_mlb_tv_mo}
        disableFreeTrial={false}
        plansSubtitle=""
        planCardsConfig={{
          plans: [canadaPlanData.mlbtv_standalone],
          tabs: [PlanIntervals.annual, PlanIntervals.monthly],
          displayMode: 'plans',
          hideTabs: true,
        }}
        valuePropsCopy={showValueProps ? valuePropsCopy : null}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 680px;
  }
`
